import type { IntelligenceLevel, TokenEstimate } from '@traceio-org/platform-contracts';

/**
 * The tokens one action uses at a level: the reference estimate times the level's multiplier in thousandths,
 * rounded half to even, exactly as platform-api's estimateMillitokens computes it for a reservation. Integer
 * arithmetic throughout; null for an action without levels (its reference applies at every level). Tokens, not
 * prices: the token price stays platform-api's.
 */
export function estimateAtLevel(estimate: TokenEstimate, level: IntelligenceLevel): number | null {
  const multiplier = estimate.levelMultipliersMilli?.[level];
  if (multiplier === undefined) return null;
  const product = estimate.referenceMillitokens * multiplier;
  const whole = Math.floor(product / 1000);
  const remainder = product % 1000;
  if (remainder > 500 || (remainder === 500 && whole % 2 === 1)) return whole + 1;
  return whole;
}
